import { Reveal, SectionLabel, MaskedLine } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The Problem",
    body: "The market is flooded with disposable gear. Bags that rip in a season. Zippers that fail on the job. The trades deserved better — and nobody was building it.",
  },
  {
    n: "02",
    title: "The Belief",
    body: "Real professionals deserve equipment built for real work. Your gear is not an accessory. It is a tool — and tools are held to a higher standard.",
  },
  {
    n: "03",
    title: "The Promise",
    body: "No gimmicks. No shortcuts. No disposable products. Every CHWA product is engineered to be the last one you ever need to buy.",
  },
];

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="relative mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
      <Reveal>
        <SectionLabel index="01" title="The Story" />
      </Reveal>

      <div className="mt-14 md:mt-20">
        <MaskedLine delay={0.1}>
          <h2 className="max-w-5xl font-display text-4xl font-semibold uppercase leading-[1.02] tracking-tight text-zinc-50 sm:text-5xl lg:text-7xl">
            Real professionals deserve equipment built for real work.
          </h2>
        </MaskedLine>
      </div>

      <div className="mt-20 space-y-0 md:mt-32">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={0.05 * i}>
            <div
              data-testid={`story-chapter-${c.n}`}
              className="relative grid gap-6 border-t border-zinc-800 py-12 md:grid-cols-12 md:py-16"
            >
              <span className="pointer-events-none select-none font-display text-7xl font-bold leading-none text-zinc-800 md:col-span-3 md:text-9xl">
                {c.n}
              </span>
              <div className="md:col-span-4">
                <h3 className="font-display text-2xl font-semibold uppercase tracking-tight text-zinc-100 sm:text-3xl">
                  {c.title}
                </h3>
              </div>
              <p className="max-w-xl text-base leading-relaxed text-zinc-400 md:col-span-5 md:text-lg">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
